export enum ContractStatusEnum {
  Active = 'Active',
  Closed = 'Cooperation closed',
}

export const contractStatusMapping: Record<ContractStatusEnum, string> = {
  [ContractStatusEnum.Active]: 'Active',
  [ContractStatusEnum.Closed]: 'Closed',
};
